import BaseApiAction from '@Actions/base-api-action';

export default class GetPlayerInfo extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'players-getPlayerInfo',
      payload: {
        user_id: this._payload.user_id,
      },
    });
  }

  onSuccess(data) {
    let profile = data.skill_profile;
    if (profile) {
      profile.reaction_time = profile.reaction_time.avg_score;
      profile.scan_frequency = profile.scan_frequency.avg_score;
      profile.pass_quality = profile.pass_quality.avg_score;
      profile.training_duration = profile.training_duration.avg_score;
      profile.scan_quality = profile.scan_quality.avg_score;
    }
    data.skill_profile = profile;
    super.onSuccess(data);
  }
}
